import { useHistory, useLocation } from "react-router-dom"

export const useNavigate = () => {
  const { search, state } = useLocation()
  const history = useHistory()
  const navigate = (path: string, { keepSearch, keepState }: { keepSearch: boolean; keepState: boolean }) => {
    const newPath = keepSearch ? `${path}${search}` : path
    const newState = keepState ? state : null
    history.push(newPath, newState)
  }
  return navigate
}
